import React from 'react'

const CopyrightNotice = () => (
  <ul id="copyright" className="ml-0 list-unstyled">
    <li>&copy; Copyright Deadly Byte Ltd. 2011 - {new Date().getFullYear()}. All Rights Reserved.</li>
  </ul>
)

export default CopyrightNotice
